module.exports = __webpack_public_path__ + "img/tarot-major-arcana-02.4155aa3e.png";